module.exports = __webpack_public_path__ + "img/diente34.03035952.png";